// extracted by mini-css-extract-plugin
export var backdropBlur = "_c3-0";
export var contentCard = "_c3-5";
export var frame = "_c3-2";
export var image = "_c3-4";
export var imagePane = "_c3-3";
export var modal = "_c3-1";